import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectPerfVsIndexCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.PERF_VS_INDEX_CAPSULE];

export const selectPerfVsIndexCapsuleState = (
    state: State,
    widgetKey: string
) => selectPerfVsIndexCapsulesState(state)[widgetKey];
